import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FCreateBucketModal from './FCreateBucketModal';

interface fCreateBucketProps {}

type ReturnData = string | null;

function fCreateBucket({}: fCreateBucketProps = {}): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(
      <FCreateBucketModal
        onOk={(value) => {
          resolve(value);
        }}
        onClose={() => {
          resolve(null);
          setTimeout(() => {
            root.unmount();
            div.remove();
          }, 300);
        }}
      />,
    );
  });
}

export default fCreateBucket;
